import { useState, useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import * as REST from '~services/rest';

export const useTyping = ({ discussionId, personId, recipientId, writingTime }) => {
  const [peerWritingTimeout, setPeerWritingTimeout] = useState(0);
  const { getAccessTokenSilently } = useAuth0();

  const markAsTyping = async () => {
    if (!discussionId || !personId || !recipientId) {
      return;
    }

    const token = await getAccessTokenSilently();
    REST.post({
      name: `chats/${discussionId}`,
      requiresAuthentication: true,
      mockFileName: 'chats/post-typing',
      params: {
        action: 'typing',
        who: personId,
        receiver: recipientId,
      },
      token,
    });
  };

  let timer;
  useEffect(() => {
    if (peerWritingTimeout <= 0) {
      clearInterval(timer);
      return;
    }

    if (!timer) {
      timer = setInterval(() => setPeerWritingTimeout(peerWritingTimeout - 1000), 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [peerWritingTimeout]);

  return {
    markAsTyping,
    isPeerWriting: peerWritingTimeout > 0,
    setIsPeerWriting: () => setPeerWritingTimeout(writingTime),
    setIsPeerNotWriting: () => setPeerWritingTimeout(0),
  };
};
